// extracted by mini-css-extract-plugin
export default {"root":"styles_root__cdkJZ","underline":"styles_underline__gMNVH","dark":"styles_dark__Q3TOp","light":"styles_light__AHnXY"};